import axios from "axios";
//import AbstractMatrixService from './AbstractMatrixService';

class MatrixService {
  getMetrics(dateRange, site) {
    return axios
      .get(`/sitecore/shell/client/Applications/altola/insights/data/content-matrix.${site}.json`)
      .then(res => {
        const response = res.data;
        response.id = "pageviews";
        //response.data = this.filter(filters, res.data.data);
        return response;
      })
      .catch(error => console.error(error));
  }
}

export default new MatrixService();



// WEBPACK FOOTER //
// ./src/data/MatrixService.dev.js